import { archiveAssetQuery } from '../mutations';
import makeRequest from '../../../../common/utils/makeRequest';

export default async function archiveAsset(
apiClient,
{ assetId })
{
  const requestParams = {
    mutation: archiveAssetQuery,
    variables: { assetId },
    context: {
      module: 'assets'
    }
  };
  const { data, error } = await makeRequest({ request: apiClient.mutate, requestParams });

  if (!data || !data.archiveAsset || error) {return null;}

  return data.archiveAsset;
}
